<template>
    <div id="product">
        <v-alert dense border="bottom" type="primary" icon="mdi-information"
            >PRODUCT INFORMATION</v-alert
        >
        <v-alert>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="6" sm="2" md="2">
                            <span class="font-weight-bold" style="color:black;"
                                >Product Group :</span
                            >
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <span style="color:black;">{{
                                detailcase.product_group
                            }}</span>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span class="font-weight-bold" style="color:black;"
                                >Product Line :</span
                            >
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span style="color:black;">{{
                                detailcase.product_line
                            }}</span>
                        </v-col>
                        <v-col cols="6" sm="2" md="2">
                            <span class="font-weight-bold" style="color:black;"
                                >Business Unit :</span
                            >
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <span style="color:black;">{{
                                detailcase.product_group
                            }}</span>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span class="font-weight-bold" style="color:black;"
                                >Product No :</span
                            >
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span style="color:black;">{{
                                detailcase.customer_product_no
                            }}</span>
                        </v-col>

                        <v-col cols="6" sm="2" md="2">
                            <span class="font-weight-bold" style="color:black;"
                                >Product Description :</span
                            >
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <span style="color:black;">{{
                                detailcase.product_description
                            }}</span>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span class="font-weight-bold" style="color:black;"
                                >Serial No :</span
                            >
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span>{{ detailcase.product_serial }}</span>
                            <v-chip
                                class="ml-2"
                                color="teal"
                                small
                                outlined
                                @click="
                                    showhistory(detailcase.product_serial),
                                        (dialoghistory = true)
                                "
                            >
                                <v-avatar left>
                                    <v-icon small>mdi-history</v-icon>
                                </v-avatar>
                                history
                            </v-chip>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-alert>
        <v-row justify="center">
            <v-dialog
                v-model="dialoghistory"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-app-bar fixed dark color="teal darken-3" data-v-f3f3eg9>
                        <v-btn icon dark @click="dialoghistory = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title
                            >Serial History :
                            {{ detailcase.product_serial }}
                            <v-chip class="ml-2" color="white" light dense>
                                <strong>{{ datahistory.length }}</strong>
                            </v-chip>
                        </v-toolbar-title>
                    </v-app-bar>
                    <v-timeline dense class="mt-12 pt-12 pr-12">
                        <v-timeline-item
                            color="teal"
                            fill-dot
                            small
                            v-for="(data_case, i) in datahistory"
                            :key="i"
                        >
                            <v-card>
                                <v-card-title class="teal white--text">
                                    {{ data_case.case_id }}
                                    <view-more
                                        class="ml-5"
                                        :maincaseid="data_case.maincase_id"
                                    />
                                </v-card-title>
                                <v-container>
                                    <v-row no-gutters>
                                        <v-col cols="8">
                                            <v-row>
                                                <v-col cols="12">
                                                    <strong
                                                        >Case Title : </strong
                                                    >{{ data_case.case_title }}
                                                </v-col>
                                                <v-col cols="12">
                                                    <strong>Site Name : </strong
                                                    >{{ data_case.site_name }}
                                                </v-col>
                                                <v-col cols="6">
                                                    <strong
                                                        >Created Date : </strong
                                                    >{{
                                                        data_case.created_date
                                                    }}
                                                </v-col>
                                                <v-col cols="6">
                                                    <strong
                                                        >Closed Date : </strong
                                                    >{{ data_case.closed_date }}
                                                </v-col>
                                                <v-col cols="6">
                                                    <strong
                                                        >Onsite Date : </strong
                                                    >{{ data_case.onsite_date }}
                                                </v-col>
                                                <v-col cols="6">
                                                    <strong>Engineer : </strong
                                                    >{{
                                                        data_case.engineer_name
                                                    }}
                                                </v-col>
                                                <v-col cols="12">
                                                    <strong>Solution : </strong
                                                    >{{ data_case.solution }}
                                                </v-col>
                                                <v-col cols="6">
                                                    <strong
                                                        >Happycall Date : </strong
                                                    >{{ data_case.hpc_date }}
                                                </v-col>
                                                <v-col cols="6">
                                                    <strong
                                                        >Happycall By : </strong
                                                    >{{ data_case.hpc_name }}
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-btn
                                                        v-if="
                                                            data_case.hpc_level ==
                                                                'L'
                                                        "
                                                        text
                                                        icon
                                                    >
                                                        <v-icon
                                                            class="display-1 "
                                                            color="red"
                                                            >mdi-emoticon-sad</v-icon
                                                        >
                                                    </v-btn>
                                                    <v-btn
                                                        v-else-if="
                                                            data_case.hpc_level ==
                                                                'M'
                                                        "
                                                        text
                                                        icon
                                                    >
                                                        <v-icon
                                                            class="display-1 "
                                                            color="amber darken-2"
                                                            >mdi-emoticon-neutral</v-icon
                                                        >
                                                    </v-btn>
                                                    <v-btn
                                                        v-else-if="
                                                            data_case.hpc_level ==
                                                                'H'
                                                        "
                                                        text
                                                        icon
                                                    >
                                                        <v-icon
                                                            class="display-1 "
                                                            color="green"
                                                            >mdi-emoticon-excited</v-icon
                                                        >
                                                    </v-btn>
                                                    {{
                                                        data_case.hpc_level_reason
                                                    }}
                                                </v-col>
                                                <v-col cols="12">
                                                    <strong>Remark : </strong>
                                                    {{ data_case.hpc_remark }}
                                                </v-col>
                                                <v-col cols="12">
                                                    <strong>Parts</strong>
                                                    <div
                                                        v-for="(r,
                                                        i) in data_case.parts"
                                                        :key="i"
                                                    >
                                                        <div class="mt-1">
                                                            <v-chip
                                                                small
                                                                class="mr-1"
                                                            >
                                                                {{ i + 1 }}.
                                                            </v-chip>
                                                            <v-chip
                                                                small
                                                                class="mr-1"
                                                                v-if="
                                                                    r.ponumber
                                                                "
                                                                >{{
                                                                    r.ponumber
                                                                }}</v-chip
                                                            >
                                                            <v-chip
                                                                small
                                                                class="mr-1"
                                                                v-if="
                                                                    r.part_name
                                                                "
                                                                >{{
                                                                    r.part_name
                                                                }}</v-chip
                                                            >
                                                            <v-chip
                                                                small
                                                                class="mr-1"
                                                                v-if="
                                                                    r.part_description
                                                                "
                                                                >{{
                                                                    r.part_description
                                                                }}</v-chip
                                                            >
                                                            <v-chip
                                                                small
                                                                class="mr-1"
                                                                v-if="
                                                                    r.ce_status
                                                                "
                                                                >{{
                                                                    r.ce_status
                                                                }}</v-chip
                                                            >
                                                        </div>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-textarea
                                                v-model="data_case.log"
                                                outlined
                                                name="input-7-4"
                                                label="Note Logs"
                                                rows="8"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </v-timeline-item>
                    </v-timeline>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import axios from "axios"
import ViewMore from "../../Inventory/components/ViewMore"
export default {
    components: {
        "view-more": ViewMore,
    },
    props: ["detailcase"],
    methods: {
        async showhistory(value) {
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/happy-call/history/` +
                value

            try {
                let { data } = await axios.get(url)
                this.datahistory = data
            } catch (error) {
                console.log(error.message)
            }
        },
    },
    data() {
        return {
            dialoghistory: false,
            datahistory: [],
        }
    },
}
</script>
